/**
 * Y-axis for charts that count people: whole-number ticks only, and a top that
 * leaves room above the tallest bar (card 266). No imports, so the unit tests
 * can load this file on its own.
 */
export type WholeNumberAxis = {
  /** Top of the axis. A whole multiple of `stepSize`. */
  max: number;
  /** Distance between ticks. Always a whole number, at least 1. */
  stepSize: number;
};

type Options = {
  /** How many gaps between ticks (2 = three gridlines). */
  intervals?: number;
  /** Share of the axis kept empty above the tallest value (0.25 = 25%). */
  headroom?: number;
};

export const getWholeNumberAxis = (
  peak: number,
  { intervals = 2, headroom = 0.25 }: Options = {}
): WholeNumberAxis => {
  const tallest = Number.isFinite(peak) && peak > 0 ? peak : 0;
  // The axis has to reach at least this high for the tallest value to sit
  // below the headroom line.
  const needed = tallest / (1 - headroom);

  let stepSize = Math.max(1, Math.ceil(needed / intervals));
  // Past 5, round to a multiple of 5 so the labels stay readable (5, 10, 15…).
  if (stepSize > 5) stepSize = Math.ceil(stepSize / 5) * 5;

  return { max: stepSize * intervals, stepSize };
};
